export default "__VITE_ASSET__IKGqs24V__"